import { Input, Modal, Spin } from "antd"
import phoneticFuntions from "../../SentenceManage/controller/phoneticFuntions"
import { useEffect, useRef, useState } from "react";
import axios from "axios";

const backend = process.env.REACT_APP_BACKEND;

function PhoneticInput ({record, dataChangeHandler}) {
  const [diacritic, setDiacritic] = useState(record.diacritic)
  const [loading, setLoading] = useState(false)
  const diacriticRef = useRef(record.diacritic)
  
  const createPhonetic = async () => {
    try {
      setLoading(true)
      const instance = {...record}
      // const instance = sourceData.slice()
      const word = instance.word;

      if (!word) {
        return Modal.error({
          title: "단어에러",
          okText: "확인",
          content: "발음기호를 생성할 영어단어가 없습니다.",
        });
      }
        
      const text = await phoneticFuntions.dotChange(word);

      const phoneticResult = await phoneticFuntions.getPhonetic(text);

      const changedValue = await phoneticFuntions.phoneticErrorChange(
        phoneticResult.data.data[0]
      );

      const convertedValue = changedValue.replaceAll(String.fromCharCode(160)," ")
      setDiacritic(convertedValue)
      instance.diacritic = convertedValue

      const values = {
        id: instance.id, 
        word: instance.word,
        ContentSettingPartsOfSpeechMaster_code:instance.ContentSettingPartsOfSpeechMaster_code,
        diacritic: convertedValue
      }
      const changePhonetic = await axios.patch(`${backend}/contents/new_word/word/list`,{values})
      if(changePhonetic.status === 200) {
        dataChangeHandler(instance, instance.indexNumber)
      }
    } catch (err) {
      console.log(err)
      Modal.error({
        title:"에러",
        content: "서버에서 에러가 발생하여 발음기호 저장이 취소되었습니다.",
        okText:"확인",
        afterClose: ()=>{setDiacritic(record.diacritic)}
      })
    } finally {
      setLoading(false)
    }

  }

  const changeValue = async () => {
    try {
      const instance = JSON.parse(JSON.stringify(record))
      const values = {
        id: record.id, 
        word: record.word,
        ContentSettingPartsOfSpeechMaster_code:record.ContentSettingPartsOfSpeechMaster_code,
        diacritic: diacritic
      }
      instance.diacritic = diacritic
      const changePhonetic = await axios.patch(`${backend}/contents/new_word/word/list`,{values})
      if(changePhonetic.status === 200) {
        dataChangeHandler(instance, instance.indexNumber)
      }
    } catch (err) {
      console.log(err)
      Modal.error({
        title:"에러",
        content: "서버에서 에러가 발생하여 발음기호를 변경하지 못했습니다.",
        okText:"확인",
        afterClose: ()=>{setDiacritic(record.diacritic)}
      })
    }
  }

  useEffect(()=>{
    setDiacritic(record.diacritic)
  },[record])

  return (
    <div>
      <Spin spinning={loading}>
        <Input 
          style={{width:"150px"}} 
          value={diacritic}
          onFocus={()=>{diacriticRef.current = diacritic}}
          onChange={(e)=>setDiacritic(e.target.value)}
          onBlur={changeValue}
        />
        <a style={{margin:"0px 5px"}} onClick={createPhonetic}>생성</a>
      </Spin>
  </div>
  )
}

export default PhoneticInput